<template>
  <div class="header-wrap">
    <div class="form-wrap">
      <el-form :model="this" :rules="rules" ref="headerTplRef">
        <div class="form-item">
          <span class="item-label">选择模板：</span>
          <div class="item-value">
            <el-button
              class="add-tpl"
              icon="el-icon-plus"
              type="text"
              @click="selectTpl"
              >选择模板</el-button
            >
            <span v-show="tplMsg.tplName" class="tpl-label"
              >模板名称：{{ tplMsg.tplName }}</span
            >
          </div>
        </div>
        <div class="form-item">
          <span class="item-label" style="padding-top: 6px">广告账户：</span>
          <div class="item-value">
            <el-form-item
              prop="adCount"
              style="margin-bottom: 0px"
              class="select-count-formItem"
            >
              <el-select
                v-model="adCount"
                placeholder="请选择广告账号"
                class="count-select-wrap"
                popper-class="count-select"
                value-key="advertiserId"
                @change="searchProList()"
                filterable
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :label="item.advertiserName + '(' + item.advertiserId + ')'"
                  :value="item"
                >
                  <div class="count-option">
                    <span class="count-item">{{ item.advertiserName }}</span>
                    <span class="count-item">ID：{{ item.advertiserId }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <!-- <div class="form-item">
          <span class="item-label" style="padding-top: 6px">推广产品：</span>
          <div class="item-value">
            <el-form-item prop="selectPro">
              <el-select
                style="width: 300px"
                v-model="selectPro"
                placeholder="请选择"
                popper-class="pro-select"
                @change="changeSelectPro"
              >
                <el-option
                  v-for="item of proList"
                  :key="item.app_cloud_id"
                  :value="item.package_name"
                  :label="item.app_name + '(' + item.package_name + ')'"
                >
                  <div class="seitem-wrap">
                    <div class="img-wrap">
                      <img class="app-img" :src="item.icon_url" />
                    </div>
                    <div class="seitem-content">
                      <span class="app-detail">{{ item.app_name }}</span>
                      <span class="app-detail">{{ item.package_name }}</span>
                    </div>
                    <svg-icon
                      :iconClass="
                        item.os_type === 'ANDROID'
                          ? 'android'
                          : item.os_type === 'IOS'
                          ? 'apple'
                          : ''
                      "
                      className="os-icon"
                    ></svg-icon>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div> -->
      </el-form>
    </div>

    <!-- 模板选择弹框 -->
    <el-dialog title="选择模板" :visible.sync="dialogVisible" width="1014px">
      <div class="modal-body">
        <div class="select-filter">
          <el-select
            style="width: 224px"
            v-model="modalData.adCount"
            placeholder="请选择"
          >
            <el-option label="全部广告账号" :value="-1"> </el-option>
            <el-option
              :label="item.company + '-' + item.advertiserName"
              :value="item.advertiserId"
              v-for="item of countList"
              :key="item.advertiserId"
            >
            </el-option>
          </el-select>
          <el-input
            style="width: 224px"
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            v-model.trim="modalData.searchStr"
          >
          </el-input>
        </div>
        <div class="table-wrap">
          <el-table
            :data="tplTableList"
            style="width: 100%"
            @select="selectRow"
            ref="tplTableRef"
            max-height="500px"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="序号"> </el-table-column>
            <el-table-column prop="templateName" label="名称">
            </el-table-column>
            <el-table-column prop="templateDesc" label="描述">
            </el-table-column>
            <el-table-column prop="advertiserNames" label="关联账号">
            </el-table-column>
            <el-table-column prop="createTimeStr" width="170" label="创建时间">
            </el-table-column>
            <el-table-column prop="creator" label="创建人"> </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <div></div>
          <div class="bottom-wrap">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmSelect">确 定</el-button>
          </div>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAdCount,
  queryTemplate,
} from "@/api/promotion-kuaishou.js";
import nameTransforUtil from "./common/nameTransforUtil.js";
export default {
  data() {
    return {
      adCount: null,
      countList: [],
      selectPro: null,
      proList: [],
      dialogVisible: false,

      modalData: {
        adCount: -1,
        searchStr: "",
        pageData: {
          total: 15,
          page: 1,
          size: 10,
        },
      },
      tplMsg: {
        tplId: "", //保存的时候需要
        tplDes: "",
        tplName: "",
      },
      tplList: [],
      selectData: null, //勾选的模板数据
      rules: {
        adCount: [
          {
            required: true,
            message: "请选择一个账户",
            trigger: "change",
          },
        ],
        selectPro: [
          {
            required: true,
            message: "请选择一个应用",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.initSelect();
  },
  computed: {
    tplTableList() {
      return this.tplList.filter((item) => {
        return (
          (this.modalData.adCount === item.advertiserIds ||
            this.modalData.adCount === -1) &&
          (this.modalData.searchStr === "" ||
            item.templateName
              .toLowerCase()
              .includes(this.modalData.searchStr.toLowerCase()))
        );
      });
    },
  },
  methods: {
    initSelect() {
      getAdCount({
        platType: "3",
      }).then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiserList;
        }
      });
    },
    searchProList() {
      // this.changeSelectPro(null);
      // this.selectPro = null;
      this.$store.commit("setadCount_k", this.adCount);
      // if (!this.adCount) {
      //   this.proList = [];
      // } else {
      //   getAdertiserProduct({
      //     advertiserId: this.adCount.advertiserId,
      //   }).then((res) => {
      //     if (res.code === "0000") {
      //       this.proList = res.toutiaoProductInfos;
      //       if (package_name) {
      //         this.selectPro = package_name;
      //         this.changeSelectPro(package_name);
      //       }
      //     }
      //   });
      // }
    },
    selectTpl() {
      this.dialogVisible = true;
      queryTemplate({
        platType: 3,
      }).then((res) => {
        if (res.code === "0000") {
          this.tplList = res.adTemplates;
        }
      });
    },
    selectRow(selection, row) {
      this.selectData = row;
      this.$refs.tplTableRef.clearSelection();
      this.$refs.tplTableRef.toggleRowSelection(row, true);
    },
    confirmSelect() {
      if (this.selectData) {
        this.dialogVisible = false;
        this.renderData();
      } else {
        this.$message({
          message: "请选择一条模板数据",
          type: "warning",
        });
      }
    },
    deleteItem(advertiserId) {
      let index = this.adCount.findIndex(
        (item) => item.advertiserId === advertiserId
      );
      if (index !== -1) {
        this.adCount.splice(index, 1);
        this.searchProList();
      }
    },
    // changeSelectPro(package_name) {
    //   let item = this.proList.find(
    //     (item) => item.package_name === package_name
    //   );
    //   this.$store.commit("setcheckedApp_k", item || {});
    // },
    //数据回显
    renderData() {
      this.tplMsg.tplId = this.selectData.id;
      this.tplMsg.tplName = this.selectData.templateName;
      this.tplMsg.tplDes = this.selectData.templateDesc;

      let data = JSON.parse(this.selectData.templateData);
      console.log("选择的数据");
      console.log(data);
      //赋值广告账号
      this.adCount = this.countList.find(
        (item) => item.advertiserId === data.advertiser_id
      );
      this.$store.commit("setadCount_k", this.adCount);
      // //选择的产品
      this.$store.commit("setcheckedApp_k", data.checkedApp);
      // this.searchProList(data.checkedApp.package_name); //带赋值的查询

      //广告计划
      this.$store.commit("set_draft_campaign_k", data.draft_campaign);
      //快手应用
      this.$store.commit(
        "set_promote_object_k",
        data.draft_adset.promote_object
      );
      //定向包
      this.$store.commit("set_targeting_k", data.draft_adset.targeting);
      //预算和出价
      this.$store.commit(
        "set_budget_and_bid_k",
        data.draft_adset.budget_and_bid
      );
      //创意组
      this.$store.commit(
        "set_creative_groups_k",
        data.draft_ad.creative_groups
      );
      //创意标题
      this.$store.commit("set_title_group_k", data.draft_ad.title_group);
      //落地页
      if (data.web_urls && data.web_urls.length > 0) {
        this.$nextTick(() => {
          this.$store.commit("set_web_url_k", data.web_urls);
        });
      }
      //分配规则
      for (let [field, value] of Object.entries(data.split_rule)) {
        this.$store.commit("set_split_rule_k", {
          key: field,
          value,
        });
      }
      //基础设置部分（抽屉出现时加载数据）
      this.$store.commit(
        "set_name_rule_k",
        nameTransforUtil.showDataToApi(data.draft_adset.name_rule)
      );
      this.$store.commit(
        "set_delivery_range_k",
        data.draft_adset.delivery_placement.delivery_range
      );
      //创意基础设置相关
      this.$store.commit(
        "set_create_name_rule_k",
        nameTransforUtil.showDataToApi(data.draft_ad.name_rule)
      );
      this.$store.commit(
        "set_scene_id_k",
        data.draft_adset.delivery_placement.scene_id
      );
      this.$store.commit("set_overlay_group_k", data.draft_ad.overlay_group);
      this.$store.commit("set_cover_mining_k", {
        smart_cover: data.draft_ad.smart_cover,
        asset_mining: data.draft_ad.asset_mining,
      });
      this.$store.commit(
        "set_action_bar_text_k",
        data.draft_ad.action_bar_text
      );
      this.$store.commit("setclickUrl_k", data.draft_ad.clickUrl);
      //创意分类
      this.$store.commit(
        "set_creative_category_k",
        data.draft_ad.creative_category
      );
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.headerTplRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .form-wrap {
    padding: 18px 24px 24px 24px;
    .form-item {
      display: flex;
      margin-bottom: 12px;
      .item-label {
        flex-shrink: 0;
        display: inline-block;
        width: 70px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      .item-value {
        position: relative;
        width: 100%;
        padding-top: 2px;
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
        /deep/ .el-form-item__content {
          line-height: 20px;
        }
        /deep/ .select-count-formItem {
          .el-form-item__error {
            left: 75px;
            top: 7px;
          }
        }
        .add-tpl {
          padding: 0px;
        }
        .tpl-label {
          font-size: 12px;
          margin-left: 10px;
        }
        .select-tip {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
          position: absolute;
          top: 4px;
          left: 0px;
          z-index: 100;
          pointer-events: none;
        }
        .count-select-wrap {
          width: 300px;
          // /deep/ .el-select__tags {
          //   display: none;
          // }
          // /deep/ .el-input__inner {
          //   border: none;
          // }
          // /deep/.el-select .el-input .el-select__caret {
          //   color: red;
          // }
        }
        .select-list {
          margin: 0px;
          padding: 12px 12px 0px 12px;
          box-sizing: border-box;
          list-style: none;
          border-radius: 4px;
          border: 1px solid rgba(239, 239, 239, 1);
          background: rgba(252, 252, 252, 1);
          display: flex;
          flex-wrap: wrap;
          max-height: 125px;
          overflow: auto;
          .select-item {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            border-radius: 2px;
            background: rgba(233, 233, 233, 0.6);
            padding: 2px 5px;
            margin: 0 12px 12px 0;
            white-space: nowrap;
            .close-btn {
              display: inline-block;
              margin-left: 6px;
              font-size: 18px;
              cursor: pointer;
              position: relative;
              top: 1px;
            }
          }
        }
      }
    }
  }
  .modal-body {
    .select-filter {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;
    }
    .table-wrap {
      min-height: 400px;
    }
    .footer-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bottom-wrap {
        display: flex;
        padding: 16px;
      }
      /deep/ .pagination-wrap {
        text-align: left;
      }
    }
  }
}
</style>
<style lang="less">
.pro-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .seitem-wrap {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0px;
    box-sizing: border-box;
    .img-wrap {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      .app-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .seitem-content {
      font-size: 12px;
      .app-detail {
        display: block;
        line-height: 16px;
      }
    }
    .os-icon {
      margin: 0 0px 0 auto;
      font-size: 18px;
    }
  }
}
.count-select {
  .el-select-dropdown__item {
    height: 45px;
    line-height: 45px;
  }
  .count-option {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .count-item {
      display: block;
      line-height: 20px;
    }
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background-color: rgba(24, 144, 255, 0.1);
  color: rgba(24, 144, 255, 1);
}
</style>